import { FC } from "react";

import { parseBoolean } from "@ryde/shared";

import { BlueCheckboxCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const SwitchAlternativeCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <BlueCheckboxCell checked={parseBoolean(value)}></BlueCheckboxCell>;
};
